<section class="centered-with-padding py-7">
  <div class="grid grid-cols-1 items-center gap-x-[52px] gap-y-4 desk:grid-cols-2">
    <div [class.desk:order-2]="data.desktopMediaSide === 'left'" class="flex flex-col gap-[18px] desk:w-[530px]">
      <app-title [title]="data.title" size="h2" />
      <div [innerHTML]="data.text" class="prose prose-sm leading-[19px] marker:text-black" handleHtmlLinks></div>
      @if (data.cta; as cta) {
        <div class="mx-auto w-fit desk:mx-0">
          <app-button [label]="cta.label" [url]="cta.url" />
        </div>
      }
    </div>
    <div [class.desk:order-1]="data.desktopMediaSide === 'left'" class="overflow-hidden rounded-2xl">
      @let media = data.media;
      <div class="relative aspect-video h-[208px] desk:h-[294px]">
        @if (media | isImage) {
          <app-image [image]="media" [isPriority]="!isImageInPreviousBlocks" [pregenerationSize]="{ width: 1280 }" />
        } @else if (media | isVideoYoutube) {
          <app-youtube-player (playRequested)="isLegendVisible.set(true)" [videoId]="media.link | youtubeIdExtractor" />
          @if (media.legend && !isLegendVisible()) {
            <div class="absolute inset-0 flex items-end bg-gradient-to-b from-transparent to-black/50 p-6">
              <span class="font-title text-[20px] font-normal leading-5 tracking-[-0.4px] text-white">{{
                media.legend
              }}</span>
            </div>
          }
        }
      </div>
    </div>
  </div>
</section>
